import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'sl21',
  templateUrl: './sl21.component.html',
  styleUrls: ['./sl21.component.scss']
})
export class Sl21Component {

    @Input() dark: boolean=false;
    @Input({required: true}) package: any;

      constructor(
    private router: Router
  ) {

  }
  ngOnInit(): void {
    console.log(this.package)
  }

  protected buttonClick(link: string): void {
    this.router.navigate([link]);
  }
}
